import {defineStore} from "pinia";
import {type ExternalBaseSettingResponse, Setting as SystemSetting} from '@/api/system/setting'
import { type Setting} from "@/stores/setting";

export type CommonState = {
    layoutRouteIsLoading: boolean
    pageGlobalIsLoading: boolean
    locale: string | 'zh-cn' | 'en'
    settingIsCached: boolean
    setting: Record<string, Setting>
}
export const useCommonStore = defineStore('common', {
    state: (): CommonState => {
        return {
            layoutRouteIsLoading: false,
            pageGlobalIsLoading: false,
            locale: 'zh-cn',
            settingIsCached: false,
            setting: {},
        }
    },
    actions: {
        async getBaseSetting(isForceRefresh?: boolean) {
            if (isForceRefresh) {
                this.settingIsCached = false
            }
            if (this.settingIsCached) {
                return this.setting
            }
            const settingArray = (await SystemSetting.externalBase()).data
            settingArray?.forEach((setting: ExternalBaseSettingResponse) => {
                if (setting.code) {
                    this.setting[setting.code] = setting
                }
            })
            this.setting['frontendFullVersion'] = {
                name: '前端版本',
                code: 'frontendFullVersion',
                value: __APP_INFO__.fullVersion,
                description: '前端版本',
            }
            this.settingIsCached = true
            return this.setting
        },
        async setLayoutRouteIsLoading(isLoading: boolean) {
            this.layoutRouteIsLoading = isLoading
        },
        async setPageGlobalIsLoading(isLoading: boolean) {
            this.pageGlobalIsLoading = isLoading
        },
        reset() {
            this.$reset()
        },
        setLocale(locale: string) {
            this.locale = locale
        },
    },
    persist: {
        storage: localStorage,
    },
})
